/**
 * @name nut-off
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuODY4IDExLjg2OGEuODguODggMCAwMS0uNDg4LjI1MmMtMS43OC4yOC0zLjU0LS4xNy00Ljg4LS42MiAwIDEuMjcyLS4yMjkgMy41NzgtLjY1MyA1LjM0N2ExMCAxMCAwIDAxLS40MTcgMS4zNjNjLS4yMS41Mi0uODIuNTUtMS4xNy4xMmExMCAxMCAwIDAxLjY3Ny0xMy4zOTMiIC8+CiAgPHBhdGggZD0iTTEyLjE0IDYuNDg1YTI3LjQgMjcuNCAwIDAwNC43MDctLjYzOEwyMCA5YTcuMjMgNy4yMyAwIDAxMS43MDYgNy4wNSIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik0yMC43MDcgMjAuNzA3QTEgMSAwIDAxMjAgMjFoLTFjLTEuMDY5IDAtMS42NDguMjQyLTIuNDg1LjU1MkE3LjIgNy4yIDAgMDE5LjAwMiAyMGwtMy4xNTUtMy4xNTMiIC8+CiAgPHBhdGggZD0iTTguMzU2IDIuN2ExMCAxMCAwIDAxOS45NzQgMS41NmMuNDMuMzUuNC45Ny0uMTIgMS4xN2ExMCAxMCAwIDAxLTEuMzYzLjQxNyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/nut-off
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const NutOff: string = `
<svg
  class="lucide lucide-nut-off"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M11.868 11.868a.88.88 0 01-.488.252c-1.78.28-3.54-.17-4.88-.62 0 1.272-.229 3.578-.653 5.347a10 10 0 01-.417 1.363c-.21.52-.82.55-1.17.12a10 10 0 01.677-13.393" />
  <path d="M12.14 6.485a27.4 27.4 0 004.707-.638L20 9a7.23 7.23 0 011.706 7.05" />
  <path d="m2 2 20 20" />
  <path d="M20.707 20.707A1 1 0 0120 21h-1c-1.069 0-1.648.242-2.485.552A7.2 7.2 0 019.002 20l-3.155-3.153" />
  <path d="M8.356 2.7a10 10 0 019.974 1.56c.43.35.4.97-.12 1.17a10 10 0 01-1.363.417" />
</svg>
`;

export default NutOff;
